import { sortBy } from 'lodash';
import Filter from '../../../../components/Filter';
import { FilterField } from '../../../../components/Filter/FilterField';
import cultivares from '../../../../services/estoque/cultivares';
import unidades from '../../../../services/estoque/unidades';
import especies from '../../../../services/geral/especies';
import camposProducao from '../../../../services/sementes/campos-producao';
import categorias from '../../../../services/sementes/categorias';
import peneiras from '../../../../services/sementes/peneiras';
import { lotesStatuses } from '../../../../utilities';

const filters: FilterField[] = sortBy([
  { field: 'pms', type: 'number', label: 'PMS' },
  { field: 'dataLote', type: 'dateInterval', label: 'Data' },
  {
    field: 'status', type: 'select', label: 'Status', items: lotesStatuses,
  },
  {
    field: 'cultivarId',
    type: 'autocomplete',
    label: 'Cultivar',
    service: cultivares,
    optionKey: 'id',
    optionLabel: 'descricaoCategoria',
    optionQuery: 'descricao',
  },
  {
    field: 'categoriaId',
    type: 'select',
    label: 'Categoria',
    service: categorias,
    optionKey: 'id',
    optionLabel: 'descricao',
  },
  {
    field: 'peneiraId',
    type: 'select',
    label: 'Peneira',
    service: peneiras,
    optionKey: 'id',
    optionLabel: 'descricao',
  },
  {
    field: 'especieId',
    type: 'select',
    label: 'Espécie',
    service: especies,
    optionKey: 'id',
    optionLabel: 'descricao',
  },
  {
    field: 'unidadeId',
    type: 'select',
    label: 'Unidade',
    service: unidades,
    optionKey: 'id',
    optionLabel: 'descricao',
  },
  {
    field: 'campo_producoes_id',
    type: 'autocomplete',
    label: 'Campo de Produção',
    service: camposProducao,
    optionKey: 'id',
    optionLabel: 'identificacaoSigef',
  },
], 'label');

const Filters = () => (
  <Filter
    context="lotes"
    filters={filters}
  />
);

export default Filters;
